<template>
	<div class="form__group">
		<multiselect :options="options" :placeholder="placeholder" :allow-empty="allowEmpty" label="name" track-by="id"
		             :show-labels="false" v-model="selected"
		             :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">>
		</multiselect>

		<label class="form__label">{{ label }}</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlRegion',
		mixins: [Select],
		props: {
			label: {
				type: String,
				default: 'Region',
			},
			name: {
				type: String,
				default: 'Region',
			},
			placeholder: {
				type: String,
				default: 'Select a region...',
			},
		},
		data() {
			return {
				options: window.regions || [],
			}
		},
	}
</script>

